export function getStateFromVehicleNumber(vehicleNumber) {
  // Extract the first two letters (state code)
  if (!vehicleNumber) return "NA";

  const stateCode = vehicleNumber.substring(0, 2).toUpperCase();

  // Mapping of state codes to state names (you can add more if needed)
  const stateMap = {
    AN: "Andaman and Nicobar Islands",
    AP: "Andhra Pradesh",
    AR: "Arunachal Pradesh",
    AS: "Assam",
    BR: "Bihar",
    CG: "Chhattisgarh",
    CH: "Chandigarh",
    DD: "Daman and Diu",
    DL: "Delhi",
    DN: "Dadra and Nagar Haveli",
    GA: "Goa",
    GJ: "Gujarat",
    HR: "Haryana",
    HP: "Himachal Pradesh",
    JH: "Jharkhand",
    JK: "Jammu and Kashmir",
    KA: "Karnataka",
    KL: "Kerala",
    LA: "Ladakh",
    LD: "Lakshadweep",
    MH: "Maharashtra",
    ML: "Meghalaya",
    MN: "Manipur",
    MP: "Madhya Pradesh",
    MZ: "Mizoram",
    NL: "Nagaland",
    OD: "Odisha",
    PB: "Punjab",
    PY: "Puducherry",
    RJ: "Rajasthan",
    SK: "Sikkim",
    TN: "Tamil Nadu",
    TR: "Tripura",
    TS: "Telangana",
    UK: "Uttarakhand",
    UP: "Uttar Pradesh",
    WB: "West Bengal",
  };

  // Return the matching state or a default message
  return stateMap[stateCode] || "Unknown State";
}

export const getUser = () => {
  const data = localStorage.getItem("user");
  return data ? JSON.parse(data) : [];
};

export function getInitials(name) {
  if (!name) return "";
  const parts = name.trim().split(" ");
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return (
    parts[0].charAt(0).toUpperCase() +
    parts[parts.length - 1].charAt(0).toUpperCase()
  );
}
